export default {
      id: "common__fuel_tank-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "img/icons.svg#common__fuel_tank",
      toString: function () {
        return this.url;
      }
    }